import { ContentState, convertFromRaw } from 'draft-js';
import { Map } from 'immutable';

import getCharCount from './getCharCount';

export default function getBlockCharCount(blockContent) {
  let contentState;

  if (typeof blockContent === 'string') {
    return getCharCount(blockContent);
  } else if (blockContent instanceof Map) {
    contentState = convertFromRaw(blockContent.toJS());
  } else if (blockContent instanceof ContentState) {
    contentState = blockContent;
  }

  return contentState
    ? getCharCount(contentState.getPlainText())
    : 0;
}
